import {
  API_ENDPOINT,
  useClientApiV1VoucherArchiveUpdateMutation,
} from '../../../../../../resources/@types/courseSchema';

export function useClientApiVoucherArchiveUpdateMutation(
  options?: Parameters<typeof useClientApiV1VoucherArchiveUpdateMutation>[0]['options'],
) {
  return useClientApiV1VoucherArchiveUpdateMutation({
    url: API_ENDPOINT.CLIENT_V1_VOUCHER_ARCHIVE,
    options,
  });
}
